<template>
  <!-- 返回首页按钮 -->
  <div>
    <empty></empty>
    <div @click="handleBack" class="backToHome fz85">
    
      {{$t('back')}}<slot></slot>
    </div>
  </div>
</template>

<script>
  import empty from './empty.vue'
  export default {
    name: 'HelloWorld',
    components:{empty},
    methods:{
      handleBack(){
        this.$router.go(-1);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .backToHome{
    display: block;
    width: 100%;
    text-decoration: none;
    position: fixed;
    bottom: 0px;
    height: 2.35rem;
    background-color:#047BCD;
    line-height: 2.3rem;
    color: #fff;
  }
  a{
    display: block;
    width: 100%
  }
  .fz85{
    font-size:0.85rem;
  }
 
</style>